import React from 'react';
import { JsonLd } from 'react-schemaorg';

const OrganizationSchema = () => (
  <JsonLd
    item={{
      '@context': 'https://schema.org',
      '@type': 'Organization',
      url: 'https://achievable.me/',
      sameAs: [
        'https://www.linkedin.com/company/achievable/',
        'https://www.facebook.com/achievableprep/',
        'https://x.com/AchievablePrep',
        'https://www.tiktok.com/@achievableprep',
      ],
      image:
        'https://assets.achievable.me/logos/achievable/logo-text-vertical_theme=default-320h.png',
      logo: 'https://assets.achievable.me/logos/achievable/logo-text-vertical_theme=default-320h.png',
      name: 'Achievable',
      legalName: 'Achievable, Inc.',
      description:
        'Achievable is the most effective way to ace your professional exams and boost your career. Study on the go from your phone or computer. Industry best pass rates.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '440 N Barranca Ave #4433',
        addressLocality: 'Covina',
        addressRegion: 'CA',
        postalCode: '91723',
        addressCountry: 'US',
      },
      contactPoint: [
        {
          '@type': 'ContactPoint',
          email: 'support@achievable.me',
          telephone: '+1 415 831 7733',
          contactType: 'Customer support',
        },
      ],
      email: 'support@achievable.me',
      telephone: '+1 415 831 7733',
      iso6523Code: '0600:080525275',
      naics: '611691',
    }}
  />
);

export default OrganizationSchema;
